/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://jpksy4um65doxdleddkjm4vhnm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:65a689aa-6608-4a12-a951-74d15e5617cd",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_dcH6e5lko",
    "aws_user_pools_web_client_id": "3nv9ib983u25qha116fj19orf2",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "deepskydadbcb44b8d76ec4b7bb9a929a25a943cf8205301-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
